import { jwtDecode } from "jwt-decode";
import { Navigate } from "react-router-dom";
import React from "react";
const useAuth = () => {
    const token = localStorage.getItem("workManagement");
    if (!token) {
        return <Navigate to="/" />;
    }
    if (token) {
        try {
            const decode = jwtDecode(token);
            // console.log("token===>", decode);
            const {
                id,
                u_name,
                role_id,
                company_id,
                dept_id,
                job_role,
                company_name,
                department_name,
            } = decode;
            return {
                id,
                u_name,
                role_id,
                company_id,
                dept_id,
                job_role,
                company_name,
                department_name,
                token,
            };
        } catch (error) {
            console.error("error decoding token:", error);
        }
    }
};
export default useAuth;